import { styled } from "@mui/material/styles";

const StyledFavItems = styled("div")(
  ({ theme }) => `
   width: 41.6%;
   height:auto;
   @media (max-width: 1025px){
   width: 100% !important;
   }
   @media (max-width: 850px){
   width: 100%;
   }
   
  .right-container {
   width: 100%;
   background-color: ${theme.palette.customColor.white};
   margin-top: 16px;
   height: calc(100% - 16px);

   @media (max-width: 600px){
   background-color: transparent;
   }

}
  
.fav-title{
font-size: 20px;
    font-weight: 500;
    font-family: 'Lexend', sans-serif;
    line-height: 24px;
    color: ${theme.palette.primary.main};
    padding-left: 20px;
    padding-top: 20px;
    margin-bottom: 16px;
    @media (max-width: 600px){
padding-left: 0px;
}
}

.button-box{
text-align: center;
margin-top: 8px;
margin-bottom: 10px;
@media (max-width: 1025px){
margin-top: 0px;
padding-bottom: 16px;
}

@media (max-width: 600px){
padding-top: 16px;
padding-bottom: 0px;
margin-bottom: 0px;
}
}

.product-button{
font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 17.5px;
    color: ${theme.palette.primary.main};
    text-transform: none;
    text-decoration: underline;
}

.content-box{
height: 100%;
}

`
);

export default StyledFavItems;
